import { createSelector } from '@reduxjs/toolkit';
import { initialState } from './crm-mails-slice';

const crmMailSlice = (state) => state.mails || initialState;
export const selectMailSent = createSelector([crmMailSlice], (state) => state.mailSent);
